// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".indicators-container[data-v-f412f460]{display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;gap:20px}@media screen and (max-width:1200px){.indicators-container[data-v-f412f460]{display:block}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
